import React, { useState } from "react";
import GetRequest from "../Services/APIRequest";
import Loading from "../Components/Loading";
import Error from "../Components/Error";

// 🔹 Date Format Helper
const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const ComplaintList = () => {
  const [searchTerm, setSearchTerm] = useState(""); // search by farmer name
  const [statusFilter, setStatusFilter] = useState("All");

  // 🔹 API Call (using your GetRequest service)
  const { error, isLoaded, data } = GetRequest(
    "/Complaint/GetAllComplaintlist/GetAllComplain"
  );

  // 🔹 Extract complaints safely - YAHAN CHANGE KARNA HAI
  const complaints = data?.result || []; // data.data ki jagah data.result

  // 🔹 Filter logic
  const filteredComplaints = complaints.filter(
    (c) =>
      (statusFilter === "All" || c.status === statusFilter) &&
      (c.farmerName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        c.farmerVillageName?.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const allStatuses = ["All", "Pending", "Resolved", "In Progress", "Closed"];

  return (
    <section className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header bg-primary text-white d-flex flex-wrap justify-content-between align-items-center">
                <h5 className="card-title mb-0">Complaint List</h5>
              </div>

              <div className="card-body">
                {/* 🔹 Status Filter */}
                <div className="mb-3">
                  <strong className="me-2">Status:</strong>
                  {allStatuses.map((status) => (
                    <button
                      key={status}
                      className={`btn btn-sm me-2 mb-2 ${
                        statusFilter === status
                          ? "btn-primary"
                          : "btn-outline-primary"
                      }`}
                      onClick={() => setStatusFilter(status)}
                    >
                      {status}
                    </button>
                  ))}
                </div>

                {/* 🔹 Search */}
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by farmer or village name..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>

                {/* 🔹 Error / Loading */}
                {error && <Error message={error.message} />}
                {!isLoaded && <Loading />}

                {/* 🔹 Mobile Cards View */}
                {isLoaded && !error && (
                  <>
                    <div className="d-block d-md-none">
                      {filteredComplaints.length === 0 ? (
                        <div className="text-center text-muted">
                          No complaints found
                        </div>
                      ) : (
                        filteredComplaints.map((c) => (
                          <div
                            key={c.id}
                            className="card mb-2 shadow-sm border"
                          >
                            <div className="card-body p-2 d-flex flex-column">
                              <h6 className="mb-1">
                                <strong>{c.farmerName}</strong>
                              </h6>
                              <p className="mb-1 text-muted small">
                                Village: {c.farmerVillageName || "-"}
                              </p>
                              <p className="mb-1 text-muted small">
                                Complaint Type: {c.complaintType?.name || "-"}
                              </p>
                              <p className="mb-1 text-muted small">
                                Reported: {formatDate(c.issueReportedDate)}
                              </p>
                              <span
                                className={`badge ${
                                  c.status === "Resolved"
                                    ? "bg-success"
                                    : c.status === "In Progress"
                                    ? "bg-warning"
                                    : c.status === "Closed"
                                    ? "bg-secondary"
                                    : "bg-danger"
                                }`}
                              >
                                {c.status || "Pending"}
                              </span>
                            </div>
                          </div>
                        ))
                      )}
                    </div>

                    {/* 🔹 Desktop Table View */}
                    <div className="table-responsive d-none d-md-block">
                      <table className="table table-bordered table-striped table-hover">
                        <thead className="table-dark">
                          <tr>
                            <th>#</th>
                            <th>Farmer Name</th>
                            <th>Village</th>
                            <th>Complaint Type</th>
                            <th>Status</th>
                            <th>Reported Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredComplaints.length === 0 ? (
                            <tr>
                              <td
                                colSpan="6"
                                className="text-center text-muted"
                              >
                                No complaints found
                              </td>
                            </tr>
                          ) : (
                            filteredComplaints.map((c, index) => (
                              <tr key={c.id}>
                                <td>{index + 1}</td>
                                <td>{c.farmerName}</td>
                                <td>{c.farmerVillageName || "-"}</td>
                                <td>{c.complaintType?.name || "-"}</td>
                                <td>
                                  <span
                                    className={`badge ${
                                      c.status === "Resolved"
                                        ? "bg-success"
                                        : c.status === "In Progress"
                                        ? "bg-warning"
                                        : c.status === "Closed"
                                        ? "bg-secondary"
                                        : "bg-danger"
                                    }`}
                                  >
                                    {c.status || "Pending"}
                                  </span>
                                </td>
                                <td>{formatDate(c.issueReportedDate)}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComplaintList;
